// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import { CatalogueProductFragmentDoc } from '../../../graphql/api/product/catalogueProduct.fragment.generated';
import { RelatedProductFragmentDoc } from '../../../components/rings/RelatedProducts.generated';
import { ProductCardFragmentDoc } from '../../../components/layout/cards/ProductCard.generated';
import { ProductLinkFragmentDoc } from '../../../router/fragments/productLink.fragment.generated';
import { EngagementRingLinkFragmentDoc } from '../../../router/fragments/engagementRingLink.fragment.generated';
import { JewelleryLinkFragmentDoc } from '../../../router/fragments/jewelleryLink.fragment.generated';
import { ReadyToGoRingLinkFragmentDoc } from '../../../router/fragments/readyToGoRingLink.fragment.generated';
import { WeddingRingLinkFragmentDoc } from '../../../router/fragments/weddingRingLink.fragment.generated';
import { MetalVariationFragmentDoc } from '../../../components/rings/MetalVariations.generated';
import { MetalFilterMetalFragmentDoc } from '../../../graphql/api/product/rings/fragments/filters/metalFilter.fragment.generated';
import { GetIsLabGrownFragmentDoc } from '../../../domain/product/getIsLabGrown.generated';
import { MoneyFragmentDoc } from '../../../graphql/api/fragments/money.fragment.generated';
import { MonolithImageSizeFragmentDoc } from '../../../components/useImageProps.generated';
import { ProductGalleryFragmentDoc } from '../../../components/layout/gallery/ProductGallery.generated';
import { ThreeSixtyFragmentDoc } from '../../../components/layout/three-sixty/ThreeSixty.fragment.generated';
import { CatalogueVideoFragmentDoc } from '../../../graphql/api/product/catalogueVideo.fragment.generated';
import { ProductPageMetaFragmentDoc } from '../composables/useProductPageMeta.generated';
import { AssetFragmentDoc } from '../../../graphql/api/fragments/asset.fragment.generated';
import { AccentGemFragmentDoc } from '../composables/useAccentGems.generated';
import { TaxSnippetFragmentDoc } from '../../../components/rings/TaxSnippet.generated';
import { RingSizeFragmentDoc } from '../../../graphql/api/product/rings/fragments/ringSize.fragment.generated';
import { RecommendedRingSizeFragmentDoc } from '../../../graphql/api/product/rings/fragments/recommendedRingSize.fragment.generated';
export const WeddingRingFragmentDoc = `
    fragment weddingRing on CatalogueWeddingRing {
  ...catalogueProduct
  ...productGallery
  ...productPageMeta
  video {
    ...catalogueVideo
  }
  accentGemItems {
    ...accentGem
  }
  categories {
    translation(locale: $locale) {
      name
    }
    systemCode
  }
  ringStyles {
    translation(locale: $locale) {
      name
    }
    systemCode
  }
  bandWidth
  bandThickness
  ...weddingRingLink
  variations {
    primaryMetal {
      ...metalFilterMetal
    }
    catalogueCode
    suffix
    productName
    ...weddingRingLink
  }
  translation(locale: $locale) {
    seoText
    description
  }
  salePrice(currency: $currency, country: $country) {
    total {
      ...money
    }
    ...taxSnippet
  }
  sizes(country: $country) {
    ... on RingSize {
      ...ringSize
    }
    ... on RecommendedRingSize {
      ...recommendedRingSize
    }
  }
}
    `;